module.exports = __webpack_public_path__ + "static/img/pggmhc.50f82792.png";